import { shipToSelectorStyles } from "@insite/content-library/Components/ShipToSelector";
import { css } from "styled-components";

shipToSelectorStyles.noAddressesText = {
    variant: "h4",
    css: css`
        font-family: "Lato";
        font-weight: normal;
    `,
};
